import { Type } from "@angular/core";
import { DefaultTriggerFormComponent } from "./default-trigger-form.component";
import { AppInstallTriggerFormComponent } from "./app-install/app-install-trigger-form.component";
import { APIRequestTriggerFormComponent } from "./api-request/api-request-trigger-form.component";
import { AppPermissionsUpdateTriggerFormComponent } from "./app-permissions-update/app-permissions-update-trigger-form.component";
import { AppUseTriggerFormComponent } from "./app-use/app-use-trigger-form.component";
import { LastSignalTriggerFormComponent } from "./last-signal/last-signal-trigger-form.component";
import { LocationUpdateTriggerFormComponent } from "./location-update/location-update-trigger-form.component";
import { OffPropertyTriggerFormComponent } from "./off-property/off-property-trigger-form.component";
import { GeofenceEntryTriggerFormComponent } from "./geofence-entry/geofence-entry-trigger-form.component";
import { GeofenceExitTriggerFormComponent } from "./geofence-exit/geofence-exit-trigger-form.component";
import { BeaconRegionEntryTriggerFormComponent } from "./beacon-region-entry/beacon-region-entry-trigger-form.component";
import { BeaconRegionExitTriggerFormComponent } from "./beacon-region-exit/beacon-region-exit-trigger-form.component";
import { OnPropertyTriggerFormComponent } from "./on-property/on-property-trigger-form.component";
import { ProfileUpdateTriggerFormComponent } from "./profile-update/profile-update-trigger-form.component";

/**
 * Maps `logic_entry_event_types.name` → Angular component that collects
 * the test-specific config for that trigger.
 *
 * Per-trigger forms are registered here as they are implemented. Anything
 * not registered falls back to `DefaultTriggerFormComponent`.
 */
export interface TriggerFormComponent {
  entryEventType?: string | null;
  configChange: any; // EventEmitter<Record<string, any>>
}

export const triggerFormRegistry: Record<string, Type<any>> = {
  AppInstall: AppInstallTriggerFormComponent,
  APIRequest: APIRequestTriggerFormComponent,
  AppPermissionsUpdate: AppPermissionsUpdateTriggerFormComponent,
  AppUse: AppUseTriggerFormComponent,
  LastSignal: LastSignalTriggerFormComponent,
  LocationUpdate: LocationUpdateTriggerFormComponent,
  OffProperty: OffPropertyTriggerFormComponent,
  GeofenceEntry: GeofenceEntryTriggerFormComponent,
  GeofenceExit: GeofenceExitTriggerFormComponent,
  BeaconRegionEntry: BeaconRegionEntryTriggerFormComponent,
  BeaconRegionExit: BeaconRegionExitTriggerFormComponent,
  OnProperty: OnPropertyTriggerFormComponent,
  ProfileUpdate: ProfileUpdateTriggerFormComponent,
  // 'Geofence Entry': GeofenceEntryTriggerFormComponent,
  // 'FollowUp':       FollowUpTriggerFormComponent,
  // 'Signal':         SignalTriggerFormComponent,
};

export function resolveTriggerForm(entryEventType?: string | null): Type<any> {
  if (!entryEventType) return DefaultTriggerFormComponent;
  return triggerFormRegistry[entryEventType] || DefaultTriggerFormComponent;
}
